import { DataTable } from "@marketplace/ui/data-table";

import { useSalesListTableColumns } from "../../hooks/use-sales-list-table-columns";
import type { SalesListItem } from "../../types";

type SalesListTableProps = {
  records: SalesListItem[];
};

export const SalesListTable: React.FC<SalesListTableProps> = ({ records }) => {
  const { columns } = useSalesListTableColumns();

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
